import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Marcas } from '../_model/marcas';
import { Produtos } from '../_model/produtos';
import { MatrixPipe } from '../_pipes/matrix.pipe';
import { MarcasService } from '../_services/marcas.service';
import { ProdutosService } from '../_services/produtos.service';
import { faLayerGroup, faCircle, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-modelo',
    templateUrl: './modelo.component.html',
    styleUrls: ['./modelo.component.less'],
    standalone: false
})
export class ModeloComponent implements OnInit {

  faLayerGroup = faLayerGroup;
  faCircle = faCircle;
  faPlus = faPlus;
  faMinus = faMinus;

  constructor(private prod: ProdutosService, private route: ActivatedRoute, private marcas: MarcasService) {
    this.route.queryParams.subscribe(params => {
      this.id = params['id'];
      var tInput = params['type'];
      if(!tInput)
        tInput = "";
      switch (tInput) {
        case 'alta': 
          this.links = [{link: '', name: 'Inicio'},{link: 'clock', name: 'Relógios'},{link: 'produtos'+location.search.replace("&id="+this.id,""),name: "Produtos"}];
          break;
        case 'relogio':
          this.links = [{link: '', name: 'Inicio'},{link: 'clock', name: 'Relógios'},{link: 'produtos'+location.search.replace("&id="+this.id,""),name: "Produtos"}];
          break;
        case 'j1':
          this.links = [{link: '', name: 'Inicio'},{link: 'joia', name: 'Joias'},{link: 'produtos'+location.search.replace("&id="+this.id,""),name: "Produtos"}];
        break;
        case 'j2':
          this.links = [{link: '', name: 'Inicio'},{link: 'joia', name: 'Joias'},{link: 'produtos'+location.search.replace("&id="+this.id,""),name: "Produtos"}];
        break;
        case 'acess':
          this.links = [{link: '', name: 'Inicio'},{link: 'acessories', name: 'Acessórios'},{link: 'produtos'+location.search.replace("&id="+this.id,""),name: "Produtos"}];
        break;
        default:
          this.links = [{link: '', name: 'Inicio'},{link: 'produtos',name: "Produtos"}];
        break;
      }
    });
  }
  links: any[] = [];
  pm_ctrl: boolean = false;
  pm2_ctrl: boolean = false;
  apiUrl: string = environment.apiUrl;
  id = "";
  produto: Produtos = new Produtos();
  marca: Marcas = new Marcas();
  media: string[][] = [];
  master: string = "";
  toMatrix: MatrixPipe = new MatrixPipe();
  caracteristicas: string[] = [];

  ngOnInit() {
    this.prod.get(Number.parseInt(this.id)).subscribe((data: Produtos) => {
      this.produto = new Produtos(data);
      var temp = this.produto.media.split(";");
      this.master = temp[0];
      temp.splice(0,1);
      temp = temp.filter(x => x != "");
      this.media = this.toMatrix.transform(temp,4);
      this.marcas.get(this.produto.marcasId).subscribe((data: Marcas) => {
        this.marca = new Marcas(data);
      });
      this.caracteristicas = this.produto.carecteristicas.split(";");
      this.caracteristicas = this.caracteristicas.filter(x => x != "");
    });
  }

  changePM() {
    this.pm_ctrl = !this.pm_ctrl;
  }
  changePM2() {
    this.pm2_ctrl = !this.pm2_ctrl;
  }

  swapImage(i: number, j: number) {
    var temp = this.media[i][j];
    this.media[i][j] = this.master;
    this.master = temp;
  }
} 
